import { render, staticRenderFns } from "./DiagnosticResume.vue?vue&type=template&id=1d48c006&"
import script from "./DiagnosticResume.vue?vue&type=script&lang=js&"
export * from "./DiagnosticResume.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports